import { render, staticRenderFns } from "./FinishedProductInventory.vue?vue&type=template&id=470bde7b"
import script from "./FinishedProductInventory.vue?vue&type=script&lang=js"
export * from "./FinishedProductInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports